import { useMemo } from 'react';
import { AuditLogTable } from '../../components/audit/AuditLogTable';
import { PageHeading } from '../../layouts/PageHeading';
import { useTenantAdminUsers } from '../../api/adminUsers';
import { useTenantContext } from '../../auth/useTenantContext';
import { useRole } from '../../auth/useRole';

export default function AuditTenant() {
  const { token, tenantCode } = useTenantContext();
  const { data: users } = useTenantAdminUsers(token, tenantCode);
  // The "Sola lettura" pill should appear only when the caller has no
  // write-capable role. tenant-admin/platform-admin always see audit with
  // their normal admin chrome.
  const { isAnyAdmin } = useRole();
  const readOnly = !isAnyAdmin;

  const availableActors = useMemo(() => {
    return (users?.data ?? []).map((u) => ({
      id: u.id,
      label: (u.email ?? u.display_name ?? `#${u.id}`) + (u.status === 'disabled' ? ' (disabilitato)' : ''),
    }));
  }, [users]);

  return (
    <div>
      <PageHeading
        scope="Verifica"
        target="azienda"
        meta="Log immutabile delle modifiche di questa azienda"
        readOnly={readOnly}
      />
      <AuditLogTable
        apiBase="tenant"
        availableTenants={[]}
        availableActors={availableActors}
        hideAdvanced
      />
    </div>
  );
}
